export default "__VITE_ASSET__DC14nUmz__"